import React, { useContext } from 'react';
import { Grid, Button, TextField } from '@mui/material';
import { inventoryContext } from 'views/Admin/Inventory/InventoryContext';
import { SearchOutlined as SearchIcon } from '@mui/icons-material';


let Filters = () => {
    let service = useContext(inventoryContext);


    return (
        <>
            <Grid item xs={3}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search SKU to view inventory"
                    value={service.search}
                    onChange={(e: any) => service.updateSearch(e.target.value)}
                />
            </Grid>
            <Grid item>
                <Button
                    type="submit"
                    variant="outlined"
                    aria-label="search"
                    onClick={() => service.getInventoriesBySku()}
                >
                    <SearchIcon />
                </Button>
            </Grid>
        </>
    );
}

export default Filters;